import { StatusBarContainer } from "./StatusBar.styles";

const StatusBar = (props) => {
const message = props && props.statusText;

return (
    <StatusBarContainer>
        <header className="App-header">
            <p>{!message ? "Loading..." : message}</p>
        </header>
    </StatusBarContainer>
);

}


export default StatusBar;